import { useCallback } from 'react';
import {
  useActionItem,
  ActionItemOperation as Operation,
} from '@workboard/action-item';

import { useAxios } from '../../hooks/useAxios';

export function usePingForStatus(aiId: string | null) {
  const { isPermitted, actionItem } = useActionItem(aiId);
  const canPingForStatus = isPermitted(Operation.pingForStatus);

  const [, postPing] = useAxios(
    {
      url: 'activity/PingAI',
      method: 'POST',
    },
    { manual: true }
  );

  const pingForStatus = useCallback(async () => {
    try {
      await postPing({
        data: { actId: aiId },
      });
      toastr?.success(
        `${actionItem?.assignee?.userName} will get a notification and an email asking for an update`
      );
    } catch (error) {
      toastr?.error(
        'There was a problem while pinging for status. Please try again later.'
      );
      console.error(error);
    }
  }, [postPing, aiId, actionItem?.assignee?.userName]);

  return [canPingForStatus, pingForStatus] as const;
}
